// extracted by mini-css-extract-plugin
export var pricesSection = "styles-module--pricesSection--GUUM9";
export var pricesTilesWrapper = "styles-module--pricesTilesWrapper--z+KXP";
export var ctaButton = "styles-module--ctaButton--51Sxc";
export var upperStrong = "styles-module--upperStrong--RF6Hu";